import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'aa-icon-circle',
    templateUrl: './icon-circle.component.html',
    styleUrls: [
        './icon-circle.component.scss'
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class IconCircleComponent
{
    @Input() faIcon: string;
    @Input() size: string = 'fa-1x';
}
